import React from 'react';
import { fireGtagEvent, getEventLabel } from '../../helpers/gtag-helpers';

const CLICK_DELAY = 250;

const trackLink = ({name, index, label, category, nonInteraction, href, onClick = () => {}}) => {
  return e => {
    // Unless the destination URL is opening in a new window, enforce a delay
    if (e.target.target !== '_blank') {
      e.preventDefault();
      setTimeout(() => document.location.href = href, CLICK_DELAY)
    }

    const eventLabel = getEventLabel(label, index);

    onClick();
    fireGtagEvent(name, eventLabel, category, nonInteraction);
  }
}

export default (eventProps) => {
  return (args) => {
    const {children, href, onClick} = args

    return (
        <a {...args} onClick={trackLink({...eventProps, href, onClick})}>{children}</a>
    )
  }
}
